// Grey placeholder cards shown while a feed's first page is loading,
// instead of a bare "Loading…" line — purely visual, no data involved.
export default function PostSkeleton({ count = 3 }) {
  return (
    <div style={wrap}>
      <style>{`
        @keyframes virsa-skeleton-pulse {
          0% { opacity: 0.55; }
          50% { opacity: 1; }
          100% { opacity: 0.55; }
        }
      `}</style>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={card}>
          <div style={headerRow}>
            <div style={avatarCircle} />
            <div style={usernameBar} />
          </div>
          <div style={imageBox} />
        </div>
      ))}
    </div>
  );
}

const wrap = { display: "flex", flexDirection: "column", gap: 16 };

const pulse = {
  background: "var(--border-soft)",
  animation: "virsa-skeleton-pulse 1.3s ease-in-out infinite",
};

const card = {
  background: "var(--bg-surface)",
  border: "1px solid var(--border-soft)",
  borderRadius: 14,
  padding: 14,
};

const headerRow = { display: "flex", alignItems: "center", gap: 10, marginBottom: 12 };

const avatarCircle = { ...pulse, width: 40, height: 40, borderRadius: "50%", flexShrink: 0 };

const usernameBar = { ...pulse, width: 110, height: 14, borderRadius: 6 };

const imageBox = { ...pulse, width: "100%", aspectRatio: "1 / 1", borderRadius: 10 };
